import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title></title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>April Wine Dinner</h1>
                  <h4 className="one">
                    April 17th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Watermelon Salad</h4>
                <h5>Sorrel, Watermelon Radish, Grapefruit, Red and Golden Beets, Pecorino, Blood Orange Vinaigrette</h5>
                <p>Paired with</p>
                <h4>Barnard Griffin Pinot Gris</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Smoked Salmon Bruschetta</h4>
                <h5>Capers, Shaved Red Onion, Fresh Dill, Honey Mustard Vinaigrette, Crostini</h5>
                <p>Paired with</p>
                <h4>Barnard Griffin Chardonnay</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Ragù Bianco Conchiglioni</h4>
                <h5>White Bolognese served with Conchiglie Pasta, Stuffed with Ricotta and Pecorino Romano Cheese Blend, Garnished with Fresh Parsley</h5>
                <p>Paired with</p>
                <h4>Barnard Griffin Red Blend</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Four</h3>
                <h4>Pineapple Upside Down Rum Cake</h4>
                <h5>Yellow Cake, Rum Soaked Pineapples and Cherries, Caramel Pineapple Icing</h5>
                <p>Paired with</p>
                <h4>Barnard Griffin Cabernet</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
